import React from 'react';
import styles from '../SaleReportPage.module.scss';

function FieldToggle({ enabled, onChange }) {
  const on = enabled !== false;

  return (
    <label
      className={`${styles.fieldToggle} ${on ? styles.fieldToggleOn : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        hidden
        checked={on}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={`${styles.fieldSwitch} ${on ? styles.fieldSwitchOn : ''}`} />
      <span className={styles.fieldToggleText}>{on ? '포함됨' : '제외됨'}</span>
    </label>
  );
}

export default FieldToggle;
